import { useState, useEffect } from 'react';

export default function Header() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <header 
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-white shadow-md' : 'bg-white'
      }`}
    >
      <div className="max-w-[1280px] mx-auto px-4 sm:px-6 lg:px-10">
        <div className="flex items-center justify-between h-20">
          <div className="flex items-center gap-3">
            <div className="w-14 h-14 sm:w-16 sm:h-16 flex items-center justify-center">
              <img 
                src="https://static.readdy.ai/image/1abc7f46dd99472a2aec050fdae7667e/0439ea2e4956e5a776095255ed102c8c.png" 
                alt="ИНГ ВАР логотип" 
                className="w-full h-full object-contain"
              />
            </div>
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden lg:flex items-center gap-8">
            <a 
              href="#equipment" 
              className="text-[15px] text-gray-700 hover:opacity-70 transition-opacity cursor-pointer"
            >
              Оборудование
            </a>
            <a 
              href="#specifications" 
              className="text-[15px] text-gray-700 hover:opacity-70 transition-opacity cursor-pointer"
            >
              Характеристики
            </a>
            <a 
              href="#applications" 
              className="text-[15px] text-gray-700 hover:opacity-70 transition-opacity cursor-pointer"
            >
              Применение
            </a>
            <a 
              href="#contacts" 
              className="text-[15px] text-gray-700 hover:opacity-70 transition-opacity cursor-pointer"
            >
              Контакты
            </a>
          </nav>

          {/* Desktop Contact Info */}
          <div className="hidden lg:flex items-center gap-6">
            <a 
              href="mailto:sales@engvar.ru" 
              className="flex items-center gap-2 text-[15px] text-gray-700 hover:opacity-70 transition-opacity cursor-pointer"
            >
              <i className="ri-mail-line text-lg"></i>
              <span>sales@engvar.ru</span>
            </a>
            <a 
              href="tel:+78124081913" 
              className="flex items-center gap-2 text-[15px] text-gray-900 font-medium hover:opacity-70 transition-opacity cursor-pointer"
            >
              <i className="ri-phone-line text-lg"></i>
              <span>+7 (812) 408-1913</span>
            </a>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className="lg:hidden w-10 h-10 flex items-center justify-center cursor-pointer"
          >
            <i className={`${isMobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'} text-2xl text-gray-900`}></i>
          </button>
        </div>

        {/* Mobile Menu */}
        {isMobileMenuOpen && (
          <div className="lg:hidden bg-white border-t border-gray-200 py-4">
            <nav className="flex flex-col gap-4">
              <a 
                href="#equipment" 
                onClick={() => setIsMobileMenuOpen(false)}
                className="text-[15px] text-gray-700 hover:text-[#1A2B4A] transition-colors cursor-pointer px-4 py-2"
              >
                Оборудование
              </a>
              <a 
                href="#specifications" 
                onClick={() => setIsMobileMenuOpen(false)}
                className="text-[15px] text-gray-700 hover:text-[#1A2B4A] transition-colors cursor-pointer px-4 py-2"
              >
                Характеристики
              </a>
              <a 
                href="#applications" 
                onClick={() => setIsMobileMenuOpen(false)}
                className="text-[15px] text-gray-700 hover:text-[#1A2B4A] transition-colors cursor-pointer px-4 py-2"
              >
                Применение
              </a>
              <a 
                href="#contacts" 
                onClick={() => setIsMobileMenuOpen(false)}
                className="text-[15px] text-gray-700 hover:text-[#1A2B4A] transition-colors cursor-pointer px-4 py-2"
              >
                Контакты
              </a>
              <div className="border-t border-gray-200 mt-2 pt-4 px-4 space-y-3">
                <a 
                  href="mailto:sales@engvar.ru" 
                  className="flex items-center gap-2 text-[15px] text-gray-700 hover:text-[#1A2B4A] transition-colors cursor-pointer"
                >
                  <i className="ri-mail-line text-lg"></i>
                  <span>sales@engvar.ru</span>
                </a>
                <a 
                  href="tel:+78124081913" 
                  className="flex items-center gap-2 text-[15px] text-gray-900 font-medium hover:text-[#1A2B4A] transition-colors cursor-pointer"
                >
                  <i className="ri-phone-line text-lg"></i>
                  <span>+7 (812) 408-1913</span>
                </a>
              </div>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
}
